import React, { useCallback, useState } from 'react';
import { Nav } from 'rsuite';

import { useResult } from '../../../../hooks/useResult';
import { HistoryPricesTab } from './components/HistoryPricesTab/HistoryPricesTab';
import { OptimizationForecastTab } from './components/OptimizationForecastTab';
import { ResultsAnalysisTab } from './components/ResultsAnalysisTab';
type TabType = 'FORECAST_OPTIMIZATION' | 'RESULT_ANALYSIS' | 'HISTORY_PRICES';

const OptimizationForecastTabMemo = React.memo(OptimizationForecastTab);
const ResultsAnalysisTabMemo = React.memo(ResultsAnalysisTab);
const HistoryPricesTabMemo = React.memo(HistoryPricesTab);

export const OptimizationTabs = () => {
  const [tab, setTab] = useState<TabType>('FORECAST_OPTIMIZATION');
  const { hasOptimization, isLoadingResult } = useResult();
  const isNotExistsOptimization = !isLoadingResult && !hasOptimization;

  const isHml = ['ipa-hml-app.infopriceti.com.br', 'localhost'].includes(window.location?.hostname);

  const handleContentChange = useCallback((value: TabType) => {
    setTab(value);
  }, []);

  const setContent = {
    FORECAST_OPTIMIZATION: <OptimizationForecastTabMemo />,
    RESULT_ANALYSIS: <ResultsAnalysisTabMemo />,
    HISTORY_PRICES: <HistoryPricesTabMemo />,
  };
  return (
    <main>
      <Nav activeKey={tab} appearance="subtle" onSelect={eventKey => handleContentChange(eventKey)}>
        <Nav.Item eventKey="FORECAST_OPTIMIZATION">Previsão de otimização</Nav.Item>
        <Nav.Item disabled={isNotExistsOptimization} eventKey="RESULT_ANALYSIS">
          Análise de resultados
        </Nav.Item>
        {isHml && (
          <Nav.Item disabled={isNotExistsOptimization} eventKey="HISTORY_PRICES">
            Histórico de preços
          </Nav.Item>
        )}
      </Nav>
      {setContent[tab]}
    </main>
  );
};
